import { saveAs as realSaveAs } from 'file-saver';
import React from 'react';
import { Subscriber } from 'rxjs';

import { Logger } from './Logger';
import { SaveFile } from './SaveFileWeb';

export interface Props {
    saveAs?: typeof realSaveAs;
}

export const PapermanForm: React.FunctionComponent<Props> = props => {
    const [ log, setLog ] = React.useState<string[]>([]);
    const [ jobInProgress, setJobInProgress ] = React.useState(false);
    const [ file, setFile ] = React.useState<File | null>(null);

    const logger = React.useMemo(
        () => new Subscriber<string>(msg => setLog(l => [ ...l, msg ]))
    , []);

    const handleFiles = React.useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
        event.persist();

        if (event.target.files !== null && event.target.files[0] !== undefined) {
            setFile(event.target.files[0]);
        } else {
            setFile(null);
        }
    }, []);

    const handleSubmit = React.useCallback((event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();

        if (file === null || jobInProgress === true) {
            return;
        }

        setJobInProgress(true);
        let savefile: SaveFile;

        try {
            savefile = new SaveFile(file, logger);
        } catch (err) {
            logger.next(`Error: ${err.message}`);
            setJobInProgress(false);

            return;
        }

        const outname: string = `paperman_${file.name}`;
        const promise: Promise<Blob> = new Promise<Blob>((resolve, reject) => {
            const chunks: string[] = [`${savefile.gameInfo.MagicString}\n`];

            savefile.parse().subscribe(
                chunk => chunks.push(chunk),
                err => {
                    reject(err);
                },
                () => {
                    resolve(new Blob(chunks));
                }
            );
        });
        promise.then(
            blob => {
                (props.saveAs || realSaveAs)(blob, outname);
                setJobInProgress(false);
            },
            err => {
                logger.next(`Error: ${err.message}`);
                setJobInProgress(false);
            }
        );
    }, [file, jobInProgress, logger, props.saveAs]);

    return (
    <form onSubmit={ handleSubmit } aria-label="Paperman">
        <p>Pick your save game:</p>
        <input
            type="file"
            onChange={ handleFiles }
            disabled={ jobInProgress }
            role="button"
            aria-label="File selection"
            />
        <br />
        <input
            type="submit"
            value="Paperman it"
            disabled={ jobInProgress }
            />
        <br />
        <Logger log={ log } />
    </form>
    );
}

export default PapermanForm;
